import { AxiosInstance } from 'axios';

import i18n from '../../../client/src/i18n/i18n';
import { NotificationType } from '../notification/notification.types';
import { generateNotification } from '../notification/notification.util';
import { KpiData } from './kpi.types';

/**
 * API Method to get the current kpi data
 * @param axios instance of axios
 * @returns current kpi data or undefined on error
 */
export const getKpiData = async (axios: AxiosInstance): Promise<KpiData | undefined> => {
  return axios
    .get('/kpi/')
    .then((res) => res.data)
    .catch((exc) => {
      generateNotification({
        type: NotificationType.ERROR,
        value: i18n.t('general.notification.error.getEmployeeUtilizationEntries'),
      });
      console.error('Error while loading productivity data', exc);
      return undefined;
    });
};
